import { useState } from 'react';
import { useFormikContext } from 'formik';
import Autosuggest from 'react-autosuggest';
import { Tag } from 'antd';
import { PrimaryButton } from 'uiKit/atoms/Button/components/PrimaryButton';
import { toast } from 'react-toastify';

import styles from './TagCreator.module.scss';
import cn from 'classnames';

const TagCreator = ({ initialTags, handleBlur, error }) => {
  const { values, setFieldValue } = useFormikContext();

  const [tags, setTags] = useState(initialTags);
  const [selectedTag, setSelectedTag] = useState(null);
  const [userValue, setUserValue] = useState('');

  const handleOnChange = (_event, { newValue }) => setUserValue(newValue);

  const inputProps = {
    placeholder: 'Enter custom tags..',
    id: 'tagIds',
    name: 'tagIds',
    value: userValue,
    onChange: handleOnChange,
    onBlur: handleBlur,
  };

  const getSuggestions = value => {
    const inputValue = value.trim().toLowerCase();
    const inputValueLength = inputValue.length;

    return inputValueLength === 0
      ? []
      : initialTags.filter(initTag => initTag.name.toLowerCase().slice(0, inputValueLength) === inputValue);
  };

  const onSuggestionsFetchRequested = ({ value }) => setTags(getSuggestions(value));

  const renderSuggestedTags = tag => tag.name;

  const getSelectedTagValue = tag => {
    setSelectedTag(tag);
    return tag.name;
  };

  const onSuggestionsClearRequested = () => setTags([]);

  const removeTag = removedTagId => {
    const updatedTags = values.tagIds.filter(({ id }) => id !== removedTagId);
    setFieldValue('tagIds', updatedTags);
  };

  const handleInputConfirm = tag => {
    if (!tag) {
      toast.error('Please, select tag from the list');
    } else {
      const isTagAlreadyPicked = values.tagIds.find(item => item.id === tag.id);

      if (tag && !isTagAlreadyPicked) {
        setFieldValue('tagIds', [...values.tagIds, tag]);
        setSelectedTag(null);
        setUserValue('');
      }

      if (isTagAlreadyPicked) {
        toast.error('This tag is already chosen. Please, choose another one');
      }
    }
  };

  return (
    <>
      <label className={styles.bns3_label} htmlFor="tagIds">
        Tags
        <span className={styles.bns3_required_sign}>&#42;</span>
      </label>
      <div
        className={cn(styles.bns3_tags_input_wrapper, {
          'is-invalid-container': error,
        })}
      >
        <Autosuggest
          inputProps={inputProps}
          suggestions={tags}
          onSuggestionsFetchRequested={onSuggestionsFetchRequested}
          onSuggestionsClearRequested={onSuggestionsClearRequested}
          getSuggestionValue={getSelectedTagValue}
          renderSuggestion={renderSuggestedTags}
          theme={styles}
        />
        <PrimaryButton
          variant="text"
          onClick={() => handleInputConfirm(selectedTag)}
          className={styles.bns3_add_tag_button}
        >
          Add
        </PrimaryButton>
      </div>

      {Boolean(values.tagIds.length) && (
        <div className={styles.bns3_tags_list_wrapper}>
          {values.tagIds.map(({ name, id }) => (
            <Tag closable onClose={() => removeTag(id)} key={id} className={styles.bns3_tag}>
              {name}
            </Tag>
          ))}
        </div>
      )}
    </>
  );
};

export default TagCreator;
